import useTranslation from './hooks/useTranslation';

import { AMOUNT_UNIT_OPTIONS, PER_UNIT_OPTIONS, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MixRateRow: FunctionComponent<Props> = ({
    chemicalId,
    className = '',
    onRateChange,
    onRatePerUnitChange,
    onRateUnitChange,
    rangeHint = null,
    rate,
    ratePerUnit,
    rateUnit,
    testId = TEST_ID
}) => {
    const {
        AMOUNT_UNIT_LABELS,
        AMOUNT_UNIT_PLACEHOLDER,
        PER_UNIT_LABELS,
        PER_UNIT_PLACEHOLDER,
        RATE_LABEL
    } = useTranslation();

    const handleRateInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        onRateChange({ chemicalId, rate: Number(event.target.value) });
    };

    const handleRateUnitInput = (event: React.ChangeEvent<HTMLSelectElement>) => {
        onRateUnitChange({ chemicalId, rateUnit: event.target.value });
    };

    const handleRatePerUnitInput = (event: React.ChangeEvent<HTMLSelectElement>) => {
        onRatePerUnitChange({ chemicalId, ratePerUnit: event.target.value });
    };

    const amountHasMatch = AMOUNT_UNIT_OPTIONS.some(option => option.value === rateUnit);
    const perHasMatch = PER_UNIT_OPTIONS.some(option => option.value === ratePerUnit);

    return (
        <div className={`${styles.row} ${className}`} data-testid={testId}>
            <span className={styles.label}>{RATE_LABEL}</span>

            <input
                className={styles.rateInput}
                data-testid={`${testId}-amount`}
                min='0'
                onChange={handleRateInput}
                step='0.1'
                type='number'
                value={rate}
            />

            <select
                className={styles.unitSelect}
                data-testid={`${testId}-amountUnit`}
                onChange={handleRateUnitInput}
                value={amountHasMatch ? rateUnit : ''}>
                {!amountHasMatch && (
                    <option disabled value=''>
                        {AMOUNT_UNIT_PLACEHOLDER}
                    </option>
                )}

                {AMOUNT_UNIT_OPTIONS.map(option => (
                    <option key={option.value} value={option.value}>
                        {AMOUNT_UNIT_LABELS[option.key]}
                    </option>
                ))}
            </select>

            <select
                className={styles.unitSelect}
                data-testid={`${testId}-perUnit`}
                onChange={handleRatePerUnitInput}
                value={perHasMatch ? ratePerUnit : ''}>
                {!perHasMatch && (
                    <option disabled value=''>
                        {PER_UNIT_PLACEHOLDER}
                    </option>
                )}

                {PER_UNIT_OPTIONS.map(option => (
                    <option key={option.value} value={option.value}>
                        {PER_UNIT_LABELS[option.key]}
                    </option>
                ))}
            </select>

            {rangeHint && <span className={styles.rangeHint}>{rangeHint}</span>}
        </div>
    );
};

export default MixRateRow;
